'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSlidedown = require('react-slidedown');

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _AmazonVanguardLetters = require('./AmazonVanguardLetters.css');

var _AmazonVanguardLetters2 = _interopRequireDefault(_AmazonVanguardLetters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonVanguardLetters = (_dec = (0, _reactCssModules2.default)(_AmazonVanguardLetters2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AmazonVanguardLetters, _Component);

  function AmazonVanguardLetters(props) {
    (0, _classCallCheck3.default)(this, AmazonVanguardLetters);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AmazonVanguardLetters.__proto__ || (0, _getPrototypeOf2.default)(AmazonVanguardLetters)).call(this, props));

    var letterTo = 'winters@amazon.com';
    var letterSubject = 'Amazon 401(k) deforestation';
    var letterText = '\nDear Mr. Winter,\n\nI participate in our retirement plan. I recently found out that the default Amazon.com 401(k) option offered by Vanguard has significant investments in companies with ties to deforestation in the Amazon rainforest. I care about these issues and do not want my retirement savings to support companies that are destroying the environment.\n\nThe data on the Amazon.com 401(k) can be found here:\nhttps://investyourvalues.org/retirement-plans/amazon-com\n\nI am proud of the steps we have taken as a company to protect the environment, but we need to push Vanguard to offer more sustainable and climate-friendly investment options if we want to continue to make a collective difference at Amazon.\n\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you soon.\n\nBest,\n    ';

    var emailHref = 'mailto:' + letterTo + '?subject=' + encodeURIComponent(letterSubject) + '&body=' + encodeURIComponent(letterText);

    _this.state = {
      showAdminLetter: false,
      emailHref: emailHref
    };
    return _this;
  }

  (0, _createClass3.default)(AmazonVanguardLetters, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showAdminLetter = _state.showAdminLetter,
          emailHref = _state.emailHref;
      //

      return _react2.default.createElement(
        'div',
        { styleName: 'letter-box' },
        _react2.default.createElement(
          'div',
          { styleName: 'letter-box-flex' },
          _react2.default.createElement(
            'div',
            { styleName: 'letter-box-label' },
            _react2.default.createElement(
              'h2',
              null,
              'Send a message to the Amazon 401(k) plan administrator'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Send a message to your 401(k) plan administrator asking them for a sustainable 401(k).'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'button',
                {
                  styleName: 'show-letter-button',
                  onClick: function onClick() {
                    _this2.setState({ showAdminLetter: !showAdminLetter });
                  }
                },
                'Letter to plan admin',
                _react2.default.createElement(_.LinkIcon, {
                  faclass: showAdminLetter ? 'fa-angle-double-up' : 'fa-angle-double-down'
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-icons' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _.Link,
                {
                  to: emailHref,
                  title: 'Send a message to your 401(k) plan administrator',
                  log: _analytics2.default.eventStaffSupport('Amazon', 'admin_message'),
                  targetBlank: true
                },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    'Email'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-envelope' })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          showAdminLetter ? _react2.default.createElement(
            'div',
            { styleName: 'company-letter-slidedown' },
            _react2.default.createElement(
              'p',
              null,
              'Your retirement plan administrator has a legal responsibility to act solely in your interest as a plan participant. Most 401(k) investors are primarily concerned with generating positive returns, but ',
              _react2.default.createElement(
                _.Link,
                {
                  to: _config2.default.routes.eduCenterFinRisks,
                  title: 'Financial risks of unsustainable investments',
                  xstrong: true
                },
                'unsustainable investments could be increasing your financial risk,'
              ),
              ' while also destroying the environment and fueling social inequality. If these are issues that you care about, then your plan administrator has a responsibility to make sure you have the option to invest sustainably. Below is a sample letter you can send to your 401(k) Plan Administrator at Amazon.com, Steve Winter (winters@amazon.com).'
            ),
            _react2.default.createElement(
              'blockquote',
              { styleName: 'company-letter-blockquote' },
              _react2.default.createElement(
                'p',
                null,
                'Dear Mr. Winter,'
              ),
              _react2.default.createElement(
                'p',
                null,
                'I participate in our retirement plan. I recently found out that the default Amazon.com 401(k) option offered by Vanguard has significant investments in companies with ties to deforestation in the Amazon rainforest. I care about these issues and do not want my retirement savings to support companies that are destroying the environment.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The data on the Amazon.com 401(k) can be found here:',
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  _.Link,
                  {
                    to: _config2.default.routes.plans + '/amazon-com',
                    title: 'Amazon.com retirement plan sustainability scorecard',
                    xstrong: true
                  },
                  'https://investyourvalues.org/retirement-plans/amazon-com'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'I am proud of the steps we have taken as a company to protect the environment, but we need to push Vanguard to offer more sustainable and climate-friendly investment options if we want to continue to make a collective difference at Amazon.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you soon.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Best,',
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'b',
                  null,
                  '[Your Name]',
                  _react2.default.createElement('br', null),
                  '[Your contact information: company department, email, phone, etc.]'
                )
              )
            )
          ) : null
        )
      );
    }
  }]);
  return AmazonVanguardLetters;
}(_react.Component)) || _class);
exports.default = AmazonVanguardLetters;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonVanguardLetters/AmazonVanguardAdminLetter.js
// module id = 1371
// module chunks = 0